import { render, staticRenderFns } from "./notice-detail.vue?vue&type=template&id=2125c77a&"
import script from "./notice-detail.vue?vue&type=script&lang=js&"
export * from "./notice-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports